import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as OccasiaLogoIcon } from '../icons/occasia-logo-icon.svg';
import { ReactComponent as OccasiaWhiteLogoIcon } from '../icons/occasia-white-logo-icon.svg';

const HeaderLogo = ({ isLandingPage, onClick }) => {
  const logoLinkProps = {
    to: '/',
    style: {
      textDecoration: 'none',
      color: 'inherit',
      display: 'flex',
      alignItems: 'center',
      gap: '2px'
    },
    ...(onClick && { onClick })
  };

  return (
    <div className="header-logo-frame">
      <Link {...logoLinkProps}>
        {isLandingPage ? (
          <OccasiaWhiteLogoIcon width="119" height="24" />
        ) : (
          <OccasiaLogoIcon width="119" height="24" />
        )}
      </Link>
    </div>
  );
};

export default HeaderLogo;

